import { FC, useState } from 'react';
import { CompanyForm, CompanyFormProps } from '../../shared/companyForm';
import { FormDatePicker, FormSwitch } from '../../../../../lib/components';
import { useTranslation } from 'react-i18next';
import Util from '../../../../../misc/util';
import { Typography } from '@mui/material';

type Props = Omit<CompanyFormProps, 'children'>;

export const HrisPauseForm: FC<Props> = (props) => {
  const { t } = useTranslation();
  const [showDate, setShowDate] = useState<boolean>(props?.initialValues?.status);

  return (
    <>
      <CompanyForm {...props}>
        {Object.keys(typeof props.initialValues === 'object' && props.initialValues).map(
          (key, index) =>
            key === 'status' ? (
              <FormSwitch
                label={t(`company:PAUSE`)}
                name={key}
                key={index}
                xs={6}
                onChangeCapture={() => {
                  setShowDate(!showDate);
                }}
              />
            ) : (
              <FormDatePicker
                name={key}
                key={index}
                xs={6}
                disabled={!showDate}
                minDate={Util.getNextDay()}
              />
            )
        )}
      </CompanyForm>
      <Typography p={2}>{t('company:PAUSE_NOTE')} </Typography>
    </>
  );
};
